<script setup>
import { ref } from 'vue';
import { signIn } from '../utils/auth';

const emit = defineEmits(['login-success', 'password-change-required']);

const username = ref('');
const password = ref('');
const error = ref('');
const loading = ref(false);

const handleSubmit = async () => {
  error.value = '';
  loading.value = true;
  try {
    const result = await signIn(username.value.trim(), password.value);
    if (result.type === 'NEW_PASSWORD_REQUIRED') {
      emit('password-change-required', result.user);
    } else {
      emit('login-success');
    }
  } catch (err) {
    error.value = err.message || 'Login failed. Please try again.';
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <div class="auth-page">
    <div class="auth-card">
      <h1>Wanderly</h1>
      <h2>Sign In</h2>
      <form
        class="auth-form"
        @submit.prevent="handleSubmit"
      >
        <div class="form-group">
          <label for="username">Email</label>
          <input
            id="username"
            v-model="username"
            type="email"
            autocomplete="username"
            required
            :disabled="loading"
          >
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input
            id="password"
            v-model="password"
            type="password"
            autocomplete="current-password"
            required
            :disabled="loading"
          >
        </div>
        <p
          v-if="error"
          class="input-error"
        >
          {{ error }}
        </p>
        <button
          type="submit"
          class="btn-primary full-width"
          :disabled="loading"
        >
          {{ loading ? 'Signing in…' : 'Sign In' }}
        </button>
      </form>
    </div>
  </div>
</template>
